export default "__VITE_ASSET__wr7d99kv__"